import {
  Typography,
  Tag,
  Col,
  Popover,
  Spin,
  Modal,
  ConfigProvider,
  Input,
  Card,
  Table,
} from "antd";
import { ConsoleSqlOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Metrics,
  sensorLive,
  Helpers,
  Colors,
  Spacing,
  channelColors as colors,
  Fonts,
  Images,
} from "../../global";
import { BsThermometerHalf } from "react-icons/bs";
import { ReactComponent as usbIcon } from "../../Assets/SVG/USBPowered.svg";
import { ReactComponent as battery100Icon } from "../../Assets/SVG/Battery100.svg";
import { ReactComponent as battery80Icon } from "../../Assets/SVG/Battery80.svg";
import { ReactComponent as battery60Icon } from "../../Assets/SVG/Battery60.svg";
import { ReactComponent as battery40Icon } from "../../Assets/SVG/Battery40.svg";
import { ReactComponent as battery20Icon } from "../../Assets/SVG/Battery20.svg";
import { ReactComponent as battery10Icon } from "../../Assets/SVG/Battery10.svg";
import { ReactComponent as batteryLowIcon } from "../../Assets/SVG/BatteryLow.svg";
import HelperService from "../../Helpers/HelperService.js";
import {
  Row,
  Icon,
  View,
  LoadingIcon,
  Graph,
  Alert,
  TableView,
} from "../../Components";
import "./Stores.css";
import _ from "lodash";
import {
  Group,
  Space,
  Paper,
  Button,
  Text,
  Tooltip,
  Title,
  Image,
  Divider,
  ActionIcon,
  Loader,
  Center,
  
  Menu,
  Container,
} from "@mantine/core";
import { MdKeyboardArrowLeft, MdOutlineRefresh } from "react-icons/md";
import { getTools } from "../../API";
import { BiDotsVertical } from "react-icons/bi";
import classes from "./Stores.module.css";
import { LineChart } from "@mantine/charts";
import sensorColumns from "../../Components/Column/SensorColumns";
import sensorReadingColumns from "../../Components/Column/SensorReadingColumns";
export const StoreOverview = (
  currentStore,
  navigate,
  project_id,
  allSites,
  setAllSites,
  expandedSensor,
  setExpandedSensor,
  ref,
  enabledAxis,
  xdataZoomed,
  displayDataZoomed,
  height,
  width,
  tempUnits,
  loading,
  graphData,
  chartUpdated,
  ResponsiveLine,
  enabledCount,
  attributeArray,
  CustomPoint,
  enabled,
  verticalLines,
  onChange,
  filteredSearch,
  setFilteredSearch,
  user,
  setRefreshLoading,
  refreshLoading
) => {
  const handleRefresh = async () => {
    setRefreshLoading(true);
    try {
      // Refetch Tools + Graph Data
      const toolsData = await getTools({
        token: user.signInUserSession.idToken.jwtToken,
      });

      // Replace Stores/Tools in Global State with fresh data
      setAllSites({
        ...allSites,
        ...toolsData.items,
      });

      console.log("AllSites updated with refreshed data");
    } catch (error) {
      console.error("Error while refreshing data:", error);
    } finally {
      setRefreshLoading(false);
    }
  };

  function celsiusToFahrenheit(celsius) {
    return (celsius * 1.8 + 32).toFixed(2);
  }


  return (
    <>
      <Group justify="space-between">
        <Button
          style={{ justifyContent: "center", alignItems: "center" }}
          color={Colors.main}
          variant="outline"
          onClick={() => navigate("/stores")}
          radius="sm"
          mr="md"
          h={43}
        >
          <MdKeyboardArrowLeft size="1.6rem" />
          <Text>Back To Stores</Text>
        </Button>
      </Group>

      <Space h="md" />

      <Paper>
        <Group justify="space-between" p="sm">
          <Group>
            <Image
              h={225}
              w={{ base: 333, sm: 350, lg: 375 }}
              radius="sm"
              src={
                currentStore?.settings?.projectImageURL
                  ? currentStore.settings.projectImageURL
                  : Images.store
              }
            />

            <div>
              <Title order={3}>{currentStore?.settings?.projectName}</Title>
              <Title order={3}>
                {"Store Number: " + currentStore?.settings?.projectIdentifier}
              </Title>
              <Title order={4}>{currentStore?.settings?.projectLocation}</Title>
              <Text c="dimmed" size="lg">
                {"Manager Name: " + currentStore?.settings?.projectOwner}
              </Text>
              <Text c="dimmed" size="lg">
                {"Phone: " + "954 555 1234"}
              </Text>
              <Text c="dimmed" size="lg">
                {"Email: " + "exampleEmail@gmail.com"}
              </Text>
            </div>
          </Group>

          <View style={{ borderRadius: "5px", overflow: "hidden" }}>
            <TableView currentStore={currentStore} allSites={allSites} />
          </View>
        </Group>

        <Space h="md" />
        <Divider />

        <Group justify="space-between" p="md">
          <Input
            placeholder="Search Records..."
            prefix={<SearchOutlined style={{ color: "#263CAB" }} />}
            style={{ width: 200, backgroundColor: "#F7F7F9" }}
            onChange={(e) => {
              const searchText = e.target.value;
              // Add your search logic here

              if (searchText === "") {
                setFilteredSearch(_.cloneDeep(currentStore));
              } else {
                var updatedTools = _.cloneDeep(currentStore?.tools);

                if (updatedTools) {
                  currentStore?.tools.forEach((toolMac) => {
                    var convertedTemp =
                      allSites[toolMac]?.convertedSensor?.sthp_temp.toFixed(2) +
                      " " +
                      allSites[toolMac]?.settings?.channels?.sthp_temp?.unit;

                    var convertedHumid;
                    if (
                      allSites[toolMac]?.settings?.channels?.sthp_humid
                        ?.enabled === true
                    ) {
                      convertedHumid =
                        allSites[toolMac]?.convertedSensor?.sthp_humid.toFixed(
                          2
                        ) +
                        " " +
                        allSites[toolMac]?.settings?.channels?.sthp_humid?.unit;
                    } else {
                      convertedHumid = null;
                    }

                    var connectionMsg;
                    if (
                      sensorLive.isLive(
                        allSites[toolMac]?.sensor?.updatedAt
                      ) === false
                    ) {
                      connectionMsg =
                        "Offline\n\r (" +
                        sensorLive.getTimeElapsedString(
                          allSites[toolMac]?.sensor?.updatedAt
                        ) +
                        ")";
                    } else {
                      connectionMsg = "Online";
                    }

                    let alerts = allSites[toolMac]?.alerts;
                    let hasAlert =
                      alerts != null &&
                      Array.isArray(alerts) &&
                      alerts.length > 0;
                    let alertLength = 0;
                    if (hasAlert) {
                      alertLength = 0;
                      alerts.forEach((alert) => {
                        alertLength += alert.alertState.alertCnt;
                      });
                    }

                    var toolType = allSites[toolMac]?.toolType.toLowerCase();
                    if (toolType === "sthp") {
                      toolType = "IntelliTemp".toLocaleLowerCase();
                    }

                    if (
                      allSites[toolMac]?.settings.toolName
                        .toLowerCase()
                        .includes(searchText.toLowerCase())
                    ) {
                      console.log(allSites[toolMac]?.settings.toolName);
                    } else if (toolType.includes(searchText.toLowerCase())) {
                      console.log(toolType);
                    } else if (
                      allSites[toolMac]?.mac
                        .toLowerCase()
                        .includes(searchText.toLowerCase())
                    ) {
                      console.log(allSites[toolMac]?.mac);
                    } else if (
                      allSites[toolMac]?.settings.toolLocation
                        .toLowerCase()
                        .includes(searchText.toLowerCase())
                    ) {
                      console.log(allSites[toolMac]?.settings.toolLocation);
                    } else if (convertedTemp.includes(searchText)) {
                      console.log(convertedTemp);
                    } else if (
                      convertedHumid &&
                      convertedHumid.includes(searchText)
                    ) {
                      console.log(convertedHumid);
                    } else if (connectionMsg.includes(searchText)) {
                      console.log(connectionMsg);
                    } else if (
                      hasAlert &&
                      alertLength > 0 &&
                      "alarm".includes(searchText.toLowerCase())
                    ) {
                      console.log(alertLength);
                    } else {
                      updatedTools = updatedTools.filter(
                        (item) => item !== toolMac
                      );
                    }
                  });

                  setFilteredSearch({
                    ...filteredSearch,
                    tools: updatedTools,
                  });
                }
              }
            }}
          />

          <Tooltip label="Refresh">
            <ActionIcon variant="default" size="lg" onClick={handleRefresh}>
              <MdOutlineRefresh />
            </ActionIcon>
          </Tooltip>
        </Group>

        {refreshLoading ? (
          <Paper p="md">
            <Center>
              <Loader color={Colors.main} />
            </Center>
          </Paper>
        ) : (
          <ConfigProvider
            theme={{
              token: {
                /* here is your global tokens */
                borderRadius: 0,
              },
              components: {
                Table: {
                  headerBg: Colors.darkLightGrey,
                },
              },
            }}
          >
            <Table
              onRow={(record, rowIndex) => {
                return {
                  style: { cursor: "pointer" },
                };
              }}
              scroll={{ y: "calc(100vh - 430px)" }}
              sticky={true}
              bordered={true}
              size={"small"}
              pagination={{
                position: ["bottomCenter"],
                defaultPageSize: 10,
                defaultCurrent: 1,
                showSizeChanger: true,
              }}
              expandable={{
                expandedRowRender: (record) => {
                  console.log("expandedRowRender:", record);
                  return (
                    <View style={{ backgroundColor: Colors.white }}>
                      <Row.ToolGraphOptions
                        tool={allSites[expandedSensor[0]]}
                      />
                      <View style={{ ...Helpers.row }}>
                        <div
                          ref={ref}
                          style={{
                            display: "flex",
                            width: "60%",
                            height: "100%",
                            ...Helpers.column,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              width: "99%",
                              height: "74%",
                              position: "absolute",
                              ...Helpers.row,
                            }}
                          >
                            {enabledAxis ? (
                              enabledAxis.map((axis, index) =>
                                Graph.AxisUsed(
                                  xdataZoomed.length,
                                  axis,
                                  enabled
                                ) &&
                                displayDataZoomed[0]?.data?.length > 1 &&
                                height ? (
                                  <Graph.YAxis
                                    units={tempUnits[index]}
                                    isLoading={loading}
                                    axis={axis}
                                    toolType={"sthp"}
                                    maxData={graphData.maxData}
                                    minData={graphData.minData}
                                    index={index}
                                    attributes={graphData.attributes}
                                  />
                                ) : (
                                  <></>
                                )
                              )
                            ) : (
                              <></>
                            )}
                            <div
                              style={{
                                display: "flex",
                                width: "calc(60% - 50px)",
                                height: "calc(100%)",
                                left: 50,
                                position: "absolute",
                                ...Helpers.row,
                              }}
                            >
                              {displayDataZoomed[0]?.data?.length > 1 &&
                              chartUpdated &&
                              !loading ? (
                                <ResponsiveLine
                                  data={chartUpdated ? displayDataZoomed : []}
                                  margin={{
                                    top: 10,
                                    right: 20,
                                    bottom: 10,
                                    left: 10,
                                  }}
                                  xScale={{
                                    type: "time",
                                    format: "native",
                                    // precision: 'hour',
                                  }}
                                  yScale={{
                                    type: "linear",
                                    min: 0,
                                    max: 1,
                                    stacked: false,
                                    reverse: false,
                                  }}
                                  gridYValues={[
                                    0,
                                    1 / 6,
                                    (2 * 1) / 6,
                                    (3 * 1) / 6,
                                    (4 * 1) / 6,
                                    (5 * 1) / 6,
                                    1,
                                  ]}
                                  gridXValues={verticalLines}
                                  // yFormat=" >-.2f"
                                  axisTop={null}
                                  axisRight={null}
                                  axisLeft={null}
                                  axisBottom={null}
                                  sliceTooltip={({ slice }) => {
                                    const apx = (size = 0, min = null) => {
                                      if (min) {
                                        if ((width / 750) * size > min)
                                          return min;
                                      }
                                      return (width / 750) * size;
                                    };
                                    const apy = (size = 0, min = null) => {
                                      if (min) {
                                        if ((height / 750) * size > min)
                                          return min;
                                      }
                                      return (height / 750) * size;
                                    };
                                    let counted = 0;
                                    const countedIncrement = (enabled) => {
                                      if (enabled) counted++;
                                    };

                                    let date = slice.points[0].data.x; //new Date(xdataZoomed[positionX]*1000)
                                    console.log("Date:", date);
                                    enabledCount = 0;
                                    slice.points.forEach((attribute) => {
                                      if (attribute) enabledCount++;
                                    });
                                    let longestData = 0;
                                    let currentData = "";
                                    let index;
                                    let dataIndex =
                                      graphData.convertedData.findIndex(
                                        (x) =>
                                          new Date(x[0] * 1000).getTime() ===
                                          date.getTime()
                                      );
                                    // newTouchPosition = dataIndex
                                    slice.points.forEach((attribute) => {
                                      index = attributeArray.findIndex(
                                        (x) => x == attribute.serieId
                                      );
                                      if (
                                        _.has(attribute.data, "y") &&
                                        attribute.data.y != null &&
                                        !isNaN(attribute.data.y)
                                      ) {
                                        currentData =
                                          attribute.data.y.toFixed(2) +
                                          " " +
                                          tempUnits[index - 1];
                                        if (currentData.length > longestData)
                                          longestData = currentData.length;
                                      }
                                    });
                                    let dateString =
                                      HelperService.formatDate(date, 1) +
                                      " " +
                                      HelperService.formatTime(date, 0);
                                    let timeLength =
                                      8 * (dateString.length + 1);
                                    let toolTipWidth = Math.max(
                                      100,
                                      Math.floor(8 * longestData),
                                      timeLength
                                    );
                                    let toolTipHeight = Math.max(
                                      apy(48 + 24),
                                      80
                                    );
                                    if (!slice) return <></>;
                                    return (
                                      <Paper
                                        h={66}
                                        w={130}
                                        key="tooltip"
                                        withBorder
                                        radius="lg"
                                        p="sm"
                                        style={{ backgroundColor: "#F2F2F4" }}
                                      >
                                        <Group gap="xs" justify="space-between">
                                          <Text fw={700} size="xs">
                                            {HelperService.formatDate(date, 1)}
                                          </Text>
                                          <Text fw={700} size="xs">
                                            {HelperService.formatTime(date, 0)}
                                          </Text>
                                        </Group>

                                        <line
                                          x1={apx(0)}
                                          x2={toolTipWidth} //Number(ticks.length)
                                          y1={toolTipHeight / (1 + 2) + 4}
                                          y2={toolTipHeight / (1 + 2) + 4}
                                          stroke={Colors.white}
                                          strokeWidth={2}
                                        />
                                        <Space h="xs" />
                                        {attributeArray.map((attribute, i) => {
                                          index = slice.points.findIndex(
                                            (point) =>
                                              point.serieId == attribute
                                          );
                                          return index > -1 &&
                                            slice.points[index] &&
                                            attribute.includes("sthp_temp") ? (
                                            <Group justify="right">
                                              <Text
                                                fw={700}
                                                size="xs"
                                                c={Colors.greenMain}
                                              >
                                                {_.has(
                                                  slice.points[index].data,
                                                  "y"
                                                ) &&
                                                graphData.convertedData[
                                                  dataIndex
                                                ][i] != null &&
                                                !isNaN(
                                                  graphData.convertedData[
                                                    dataIndex
                                                  ][i]
                                                )
                                                  ? graphData.convertedData[
                                                      dataIndex
                                                    ][i].toFixed(2) +
                                                    " " +
                                                    tempUnits[i - 1]
                                                  : "null"}
                                              </Text>
                                              {countedIncrement(
                                                slice.points[index]
                                              )}
                                            </Group>
                                          ) : (
                                            <></>
                                          );
                                        })}
                                      </Paper>
                                    );
                                  }}
                                  colors={(d) => d.color}
                                  enablePoints={false}
                                  enableSlices="x"
                                  // crosshairType="cross"
                                  legends={[]}
                                  enableCrosshair={false}
                                  motionConfig="gentle"
                                  layers={[
                                    "grid",
                                    "markers",
                                    "axes",
                                    "areas",
                                    "crosshair",
                                    "lines",
                                    "points",
                                    CustomPoint,
                                    "slices",
                                    "mesh",
                                    "legends",
                                  ]}
                                  animate={false}
                                />
                              ) : (
                                <View
                                  style={{
                                    ...Helpers.fillCenter,
                                    height: "100%",
                                  }}
                                >
                                  {console.log(
                                    "displayDataZoomed:",
                                    displayDataZoomed
                                  )}
                                  {!chartUpdated || loading ? (
                                    <Spin size="large" />
                                  ) : (
                                    <Text
                                      as={"xlarge"}
                                      color={"darkGrey"}
                                      weight={"bold"}
                                    >
                                      {_.isEqual(displayDataZoomed, []) ||
                                      displayDataZoomed[0]?.data?.length == 0
                                        ? "No Graph Data Available For This Scope"
                                        : "Not Enough Data to Graph"}
                                    </Text>
                                  )}
                                </View>
                              )}
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            width: "38%",
                            ...Helpers.row,
                          }}
                        >
                          <Card
                            title={
                              <Text
                                as="md"
                                weight="medium"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                Recent Sensor Readings
                              </Text>
                            }
                            style={{ borderRadius: "5px" }}
                          >
                            <Table
                              style={{ padding: 0, marginTop: 10 }}
                              scroll={{ y: 183 }}
                              size="small"
                              columns={sensorReadingColumns(
                                graphData,
                                allSites,
                                expandedSensor
                              )}
                              dataSource={displayDataZoomed[0]?.data}
                            ></Table>
                          </Card>
                        </div>
                      </View>
                      <View
                        style={{ paddingLeft: 50, width: width, height: 20 }}
                      >
                        {xdataZoomed.length > 1 &&
                        !loading &&
                        displayDataZoomed[0]?.data?.length > 1 ? (
                          <Graph.XAxis
                            xdata={xdataZoomed}
                            isLoading={loading}
                            yAxisEnabledCount={1}
                            axisWidth={50}
                            // style={{marginLeft:50}}
                            horizontalContentInset={{ right: 20, left: 10 }}
                            width={width - 50}
                            landscape={true}
                            verticalLines={verticalLines}
                            setVerticalLines={(lines) =>
                              (verticalLines = lines)
                            }
                          />
                        ) : (
                          <></>
                        )}
                      </View>
                    </View>
                  );
                },
                expandRowByClick: true,
                columnWidth: 0,
                expandedRowKeys: expandedSensor,
                onExpandedRowsChange: (expandedRows) => {
                  console.log("expandedRows:", expandedRows);
                },
                onExpand: (expanded, record) => {
                  if (expanded) {
                    setAllSites({ ...allSites, graphUpdated: false });
                    setExpandedSensor([record]);
                  } else {
                    setAllSites({ ...allSites, graphUpdated: false });
                    setExpandedSensor([]);
                  }
                },
              }}
              rowClassName={(record) =>
                expandedSensor.includes(record) ? "expanded-row" : ""
              }
              rowKey={(record) => record}
              columns={sensorColumns(navigate, allSites, filteredSearch)}
              dataSource={filteredSearch?.tools}
              onChange={onChange}
            />
          </ConfigProvider>
        )}
      </Paper>
    </>
  );
};

export default StoreOverview;